import { render } from "./Bulkupload.vue?vue&type=template&id=2a0510c4&scoped=true"
import script from "./Bulkupload.vue?vue&type=script&lang=js"
export * from "./Bulkupload.vue?vue&type=script&lang=js"

import "./Bulkupload.vue?vue&type=style&index=0&id=2a0510c4&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0510c4"]])

export default __exports__